import React from 'react';
//import ServiceBox from './ServiceBox/ServiceBox';
import Accordion from 'react-tiny-accordion'

const TreatmentAccordion = () => {
    return (
        <section className="accordion">
            <div className="container">
                <Accordion className='accordion__container' selectedIndex={0}>
                    <div data-header="Rehabilitacja ogólnoustrojowa">
                        Indywidualny dobór metod fizjoterapeutycznych do jednostek 
                        chorobowych pacjenta w&nbsp;celu przywrócenia całkowitej lub 
                        możliwej do osiągnięcia sprawności fizycznej.
                    </div>
                    <div data-header="Rehabilitacja pourazowa">
                        Przywrócenie funkcji struktur utraconych w&nbsp;wyniku szerokorozumianego 
                        urazu. Praca nad odtworzeniem: zakresu ruchu, siły mięśniowej, 
                        poprawnym wzorcem ruchu.
                    </div>
                    <div data-header="Terapia manualna">
                        Holistyczna ocena pacjenta oparta na wiedzy fizjologicznej i&nbsp;zasadach 
                        biomechaniki. Działanie manualne wykorzystujące 
                        szereg technik specjalistycznych na poszczególne elementy 
                        aparatu ruchu i&nbsp;narządy wewnętrzne.
                    </div>
                    <div data-header="Masaż klasyczny">
                        Mechaniczne drażnienie tkanek powierzchniowych celu wywołania 
                        odczynów fizjologicznych działających leczniczo, profilaktycznie bądź relaksująco.
                    </div>
                    <div data-header="Masaż sportowy">
                        Element przyśpieszenia regeneracji sportowców. Wykonywany 
                        aby zwalczać objawy przetrenowania i&nbsp;zapobiegać urazom.
                    </div>
                    <div data-header="Trening medyczny">
                        Indywidualny dobór ćwiczeń fizycznych dostosowany do 
                        możliwości funkcjonalnych pacjenta.
                    </div>
                    <div data-header="Suche igłowanie">
                        Terapia punktów spustowych przy użyciu specjalnych igieł. 
                    </div>
                    <div data-header="Kinesjotaping">
                        Metoda terapetyczna wykorzystująca specjalną strukturę taśmy 
                        elastycznej. W&nbsp;zależności od metody aplikacji plastra działa 
                        przeciwbólowo, przeciwobrzękowo, korekcyjnie.
                    </div>
                </Accordion>
            </div>
        </section>
    );
}

export default TreatmentAccordion;